import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import InfoPopoverCommentsWrapper from '../InfoPopoverCommentsWrapper';

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
    background: '#616468',
    width: '200px',
    overflowX: 'unset',
    overflowY: 'unset',
    '& .MuiTypography-root': {
      color: '#fff',
    },
  },
  InfoIconStyle: {
    color: '#91979D',
    '&:hover': {
      color: '#616569',
    },
  },
}));

export default function InfoPopover({ dashboardComments, dashboardSectionText, onCommentUpdate }) {
  const classes = useStyles();

  return (
    <Box className={classes.popoverOuter} display="flex">
      <InfoPopoverCommentsWrapper
        dashboardComments={dashboardComments}
        section="Header"
        title={dashboardSectionText}
        onCommentUpdate={onCommentUpdate}
      />
    </Box>
  );
}
